module.exports = __webpack_public_path__ + "static/media/firstam_ellen.bc8735a1.jpg";